import React, { useState } from "react";
import { importSalaryExcel } from "../../../actions/employeeSalaryActions";
import { useDispatch } from "react-redux";
import { Upload, Button, Typography, Card, message, Spin, Row, Col } from "antd";
import { UploadOutlined, DownloadOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const { Title } = Typography;

const ExcelImport = () => {
  const dispatch = useDispatch();
  const [file, setFile] = useState(null);
  const [logs, setLogs] = useState(null);
  const [loading, setLoading] = useState(false);

  // Handle file selection
  const handleFileChange = (info) => {
    if (info.file.status === "removed") {
      setFile(null);
    } else {
      const selectedFile = info.file.originFileObj || info.file;
      setFile(selectedFile);
    }
  };

  // Upload Excel
  const handleUpload = async () => {
    if (!file) return message.warning("Please select a file first");
    setLoading(true);
    try {
      const result = await dispatch(importSalaryExcel(file));
      setLogs(result.logs);
      message.success("Upload successful!");
    } catch (error) {
      console.error(error);
      message.error("Upload failed");
    }
    setLoading(false);
  };

  // Download Salary Template
  const handleDownloadTemplate = () => {
    const worksheetData = [
      ["employee_pin", "bankAccount", "grossSalary", "attendanceBonus", "medAllowance", "foodAllowance", "convenience"],
      // ["12345", "1234567890", 50000, 750, 1250, 450], // Example row
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "SalaryTemplate");
    const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

    try {
      saveAs(new Blob([wbout], { type: "application/octet-stream" }), "SalaryTemplate.xlsx");
      message.success("Template downloaded!");
    } catch (error) {
      console.error(error);
      message.error("Failed to download template");
    }
  };

  return (
    <Card style={{ maxWidth: 1200, margin: "10px auto" }}>
      {/* <Title level={3} style={{ textAlign: "center" }}>Import Salary Excel</Title> */}
      <Row gutter={24}>
        {/* Download Template Column */}
        <Col xs={24} md={8}>
          <Card
            style={{
              marginBottom: 16,
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              background: "#f6ffed",
              border: "1px solid #b7eb8f"
            }}
            bodyStyle={{ width: "100%", padding: "32px 16px" }}
          >
            <Button
              type="default"
              icon={<DownloadOutlined />}
              style={{ width: "100%", fontWeight: "bold", fontSize: 16 }}
              onClick={handleDownloadTemplate}
            >
              Download Template
            </Button>
            <div style={{ marginTop: 16, color: "#389e0d", textAlign: "center" }}>
              <span>Get the Excel format for salary import</span>
            </div>
          </Card>
        </Col>

        {/* Upload & Logs Column */}
        <Col xs={24} md={16}>
          <Card style={{ background: "#fffbe6", border: "1px solid #ffe58f" }}>
            <Upload
              beforeUpload={() => false}
              onChange={handleFileChange}
              accept=".xlsx,.xls"
              showUploadList={{ showRemoveIcon: true }}
              maxCount={1}
              style={{ marginBottom: 16 }}
            >
              <Button icon={<UploadOutlined />} style={{ width: "100%", backgroundColor: "green", color: "white", fontWeight: "bold", marginBottom:"20px" }}>
                Select Excel File
              </Button>
            </Upload>

            <Button
              type="primary"
              onClick={handleUpload}
              disabled={!file || loading}
              style={{ width: "100%", marginBottom: "20px", fontWeight: "bold" }}
            >
              {loading ? <Spin size="small" /> : "Upload Salary Excel Data"}
            </Button>

            {/* Logs */}
            {logs && (
              <Card
                title="Logs"
                style={{ background: "#fafafa", marginTop: 16 }}
                size="small"
              >
                <pre style={{ fontSize: 13, whiteSpace: "pre-wrap" }}>
                  {JSON.stringify(logs, null, 2)}
                </pre>
              </Card>
            )}
          </Card>
        </Col>
      </Row>
    </Card>
  );
};

export default ExcelImport;